import { graphql } from '@/gql';
import type { PlannerId, PublicReview } from '@/types/app';

// TODO: このメソッドを使うReviewRepositoryにあったLP用の実装をLPページ配下にComposableとして実装する
export const useGetPublicReviewsForRakuten = () => {
  const {
    public: { serverEnv },
  } = useRuntimeConfig();

  // NOTE: 表示するクチコミは決め打ち
  // https://scrum.kagam.in/project/asuka-okane-kenko40/us/796
  // https://www.notion.so/400f/for-_-ID2-714df1e71c3642ec80269defa85cf5eb
  // 表示順は、濱崎さん、小林さん、春木さんの順番
  // 1273: 濱崎さん
  // 1260: 小林さん
  // 1642: 春木さん

  const isProduction = serverEnv === 'production';
  const plannerIds: PlannerId[] = isProduction ? [1273, 1260, 1642] : [6, 7, 8];
  const publicReviews = ref<PublicReview[]>([]);

  (async () => {
    const { data } = await useAsyncQuery(
      graphql(`
        query useGetPublicReviewsForRakutenPlanner($ids: [ID!]!) {
          plannersByIds(ids: $ids) {
            id
            name
            avatar
          }
        }
      `),
      {
        ids: plannerIds.map((id) => id.toString()),
      }
    );

    const planners = data.value?.plannersByIds ?? [];

    // superfrogのplannersByIdsは順番を保証していないため、毎回表示されるプランナーの順番が異なる
    // 冗長だが、findでプランナーをidで固定させて、それを使うようにしている
    const planner1 = planners.find(
      (planner) => planner.id === (isProduction ? '1273' : '6')
    );
    const planner2 = planners.find(
      (planner) => planner.id === (isProduction ? '1260' : '7')
    );
    const planner3 = planners.find(
      (planner) => planner.id === (isProduction ? '1642' : '8')
    );

    if (planner1) {
      // 濱崎さんのレビュー↓
      // review id: 679
      const review1: PublicReview = {
        review: `ずっと何年も前から、専門のひとに相談したい。と思ってたのですが、お金の事は恥ずかしくて相談出来ずにいました。今回、勇気を、出して相談出来て本当に良かったと思っています。優先順位が確定した事。将来に対しての不安を和らげることが出来ました。`,
        score: 5,
        user: {
          birthYear: 1975,
          personalityId: 2,
          sex: 'female',
        },
        planner: {
          ...planner1,
          id: Number(planner1.id),
          avatarUrl: planner1.avatar || undefined,
        },
      };

      publicReviews.value = [review1];
    }

    if (planner2) {
      // 小林さんのレビュー↓
      // review id: 676
      const review2: PublicReview = {
        review: `チャットで本当に相談に乗ってくださる方が見つかるのかな？と不安がありましたが、思っていたより早くコメントをいただけて、スムーズに悩みを解消でき大変助かりました。
親身に相談にのってくださるIFAの方に出会えましたので、こちらを利用して良かったと思っています。ありがとうございました。`,
        score: 5,
        user: {
          birthYear: 1973,
          personalityId: 3,
          sex: 'female',
        },
        planner: {
          ...planner2,
          id: Number(planner2.id),
          avatarUrl: planner2.avatar || undefined,
        },
      };

      publicReviews.value = [...publicReviews.value, review2];
    }

    if (planner3) {
      // 春木さんのレビュー↓
      // review id: 9382
      const review3: PublicReview = {
        review: `悩んでいたことに対して、解決するようアドバイスをいただきました。もっと、早くお話を聞けたら、これまで運用に失敗したり、時間を無駄にしなかったのではないかと思います。運用のプロにご相談できたことは、本当に良かったです。`,
        score: 5,
        user: {
          birthYear: 1981,
          personalityId: 1,
          sex: 'female',
        },
        planner: {
          ...planner3,
          id: Number(planner3.id),
          avatarUrl: planner3.avatar || undefined,
        },
      };

      publicReviews.value = [...publicReviews.value, review3];
    }
  })();

  return publicReviews;
};
